import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/646a4719-dddf-47f5-9b34-85f6addb828e",
        "alt": "Unordered list renders as a list with a visual indicator such as a checkmark"
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use an unordered list to group related items together. It is suitable for presenting a collection of items that do not require a specific order or ranking. The unordered list provides visual dashes for each item, which helps to emphasize the individuality of each point and makes it easier for users to scan and comprehend the information.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/3746552a-8fd2-4fbf-9ad5-ed9b1bdcff0d" alt="" />
    <Caption mdxType="Caption">
      Use an unordered list to present and group a list of items that don't
      require a specific order.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/5df3fd9d-5508-48b1-a4e4-7891d6ecabb3" alt="" />
    <Caption mdxType="Caption">
      Don't use an unordered list to present a sequence of steps. Use an ordered
      list instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Use the unordered list to effectively provide a quick reference or highlight key points. This allows users to easily grasp the main ideas or features without having to read lengthy paragraphs. For lists that require a linear order, consider using an `}<a parentName="p" {...{
        "href": "/components/OrderedList"
      }}>{`ordered list`}</a>{` instead.`}</p>
    <p>{`The unordered list should have concise and short items. Avoid using long sentences or paragraphs as they can be difficult to scan and comprehend. If you need to include a long item or even headings and links, consider using a `}<a parentName="p" {...{
        "href": "/components/Pillar"
      }}>{`pillar`}</a>{`, a `}<a parentName="p" {...{
        "href": "/components/Card"
      }}>{`card`}</a>{` or a `}<a parentName="p" {...{
        "href": "/components/River"
      }}>{`river`}</a>{` instead.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/990a350b-cc8c-42f1-88db-662b5609a179" alt="" />
    <Caption mdxType="Caption">
      Use an unordered list for short and concise content items.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/a416e1e6-58e6-4710-a2f9-646513853dcc" alt="" />
    <Caption mdxType="Caption">
      Don't use an unordered list for long and rich sentences, paragraphs,
      headings or links. Use a pillar, card or river components instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Variant`}</h3>
    <p>{`The unordered list uses a dash to indicate each item in the list. The dash is the default variant and is suitable for most use cases. You can use check icons to indicate a list of features or benefits that are supported by the application. This way users can easily check off or easily compare the features that they might be interested in.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/afd68e16-0345-4085-b549-82647ca8136a" alt="" />
    <Caption mdxType="Caption">
      Use the check variant to indicate a list of features that are supported.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/7d8ddb4b-1a37-4b7b-a773-1eaeb9027d46" alt="" />
    <Caption mdxType="Caption">
      Don't include mutliple benefits in one single items, split them into
      multiple ones for better readability.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/OrderedList"
        }}>{`Ordered list`}</a>{`: to display a list of plain content items.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Pillar"
        }}>{`Pillar`}</a>{`: To display related content with less visual emphasis.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Card"
        }}>{`Card`}</a>{`: to display navigational related content with higher visual weight.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      